export default "<div class=\"container mat-typography\" fxLayout=\"column\">\n    <app-header></app-header>\n    <router-outlet></router-outlet>\n</div>"